import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC } from "react";
import { css } from "styled-components";

type Props = WidgetProps;

export interface GAIAStaticPageBannerWrapperStyles {
    wrapper?: InjectableCss;
}

export const styles: GAIAStaticPageBannerWrapperStyles = {
    wrapper: {
        css: css`
            width: 100%;
            margin: 0px auto;
            > div[class^="Wrapper"] {
                > div[class^="GridWrapper"] {
                    padding: 0px;
                    margin: 0px;
                    > [class^="GridOffset"] > div[class^="GridItemStyle"] > div[class^="Wrapper"] > div[class^="sc"] {
                        min-height: 8rem;
                        h2 {
                            margin-bottom: 0rem;
                        }
                    }
                }
            }
        `,
    },
};

const GAIAStaticPageBannerWrapper: FC<Props> = ({ id }) => {
    return (
        <StyledWrapper {...styles.wrapper}>
            <Zone contentId={id} zoneName="BannerWrapper" />
        </StyledWrapper>
    );
};

const staticPageBannerWrapper: WidgetModule = {
    component: GAIAStaticPageBannerWrapper,
    definition: {
        group: "Common",
        displayName: "GAIA Static Page Banner Wrapper",
    },
};

export default staticPageBannerWrapper;
